import { ActionEvent, Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
  send(event: ActionEvent) {
    if (event.params["event"]) {
      window.plausible(event.params["event"], event.params["props"]);
    }
  }
}
